import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "../lib/LocalizedLink";
import { t } from "../lib/ui";
import { brand } from "../mock/content";

const IRS_IMAGES = {
  impact: "/img/ext/b150ac891f91cfa65e7a8d44b0169f9e8594a1af8feb6ed6ef73a762547a-9b71bb.webp",
  footstep: "/img/ext/1aecc767ace450f3b9db188034feb8eb9e4d534d92b4a2314dd426092aaa-ea1628.webp",
};
const VARIANTS = ["impact", "footstep"];

// Scie di grandine dorata (solo variante "impact")
const HAIL = [
  { left: "40%", delay: "0s", dur: "2.6s", h: "48px" },
  { left: "50%", delay: "0.9s", dur: "3.1s", h: "64px" },
  { left: "58%", delay: "0.4s", dur: "2.3s", h: "40px" },
  { left: "66%", delay: "1.4s", dur: "2.9s", h: "56px" },
  { left: "74%", delay: "0.2s", dur: "3.4s", h: "70px" },
  { left: "82%", delay: "1.1s", dur: "2.5s", h: "44px" },
];

const IMG_MASK = "linear-gradient(to right, transparent 0%, #000 48%, #000 100%)";

// Striscia pubblicitaria IRS — orizzontale, compatta. Ruota tra le varianti ogni 4s.
export const IrsBanner = ({ className = "" }) => {
  const [active, setActive] = React.useState("impact");
  React.useEffect(() => {
    const id = setInterval(() => setActive((p) => (p === "impact" ? "footstep" : "impact")), 4000);
    return () => clearInterval(id);
  }, []);

  return (
    <Link
      to="/tecnologia#irs"
      data-testid="irs-banner"
      data-variant={active}
      aria-label={t("irs_banner_title")}
      className={`group relative block overflow-hidden bg-[#0B0B0B] border-y border-white/10 ${className}`}
    >
      <div className="absolute inset-0 pointer-events-none" style={{ background: "radial-gradient(130% 150% at 82% 50%, rgba(201,162,39,0.20), rgba(201,162,39,0) 55%)" }} />
      <div
        className="absolute inset-0 pointer-events-none opacity-[0.06]"
        style={{ backgroundImage: `linear-gradient(${brand.yellow} 1px, transparent 1px), linear-gradient(90deg, ${brand.yellow} 1px, transparent 1px)`, backgroundSize: "22px 22px" }}
      />
      {/* Immagini integrate nello sfondo — crossfade tra le varianti */}
      {VARIANTS.map((v) => (
        <div
          key={v}
          className="absolute inset-y-0 right-0 w-[70%] sm:w-[62%] md:w-[55%] pointer-events-none transition-opacity duration-700 ease-in-out"
          aria-hidden
          style={{ WebkitMaskImage: IMG_MASK, maskImage: IMG_MASK, opacity: active === v ? 1 : 0 }}
        >
          <img
            src={IRS_IMAGES[v]}
            alt=""
            className="w-full h-full object-cover object-center opacity-95 group-hover:scale-105 transition-transform duration-700"
            style={{ mixBlendMode: v === "footstep" ? "normal" : "screen" }}
          />
        </div>
      ))}
      {/* Grandine dorata in movimento — solo variante "impact" */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none transition-opacity duration-700" style={{ opacity: active === "impact" ? 1 : 0 }} aria-hidden>
        {HAIL.map((s, i) => (
          <span key={i} className="irs-hail" style={{ left: s.left, height: s.h, animationDelay: s.delay, animationDuration: s.dur }} />
        ))}
      </div>
      <div className="relative max-w-[1440px] mx-auto px-5 md:px-10">
        <div className="flex items-center justify-between gap-4 h-[96px] md:h-[124px]">
          <div className="min-w-0">
            <span className="block text-[11px] md:text-[11px] uppercase tracking-[0.2em] font-bold" style={{ fontFamily: "Space Grotesk", color: brand.yellow }}>
              {t("irs_banner_eyebrow")}
            </span>
            <h3 className="mt-1 text-white font-black leading-tight md:leading-none text-lg sm:text-xl md:text-3xl tracking-tight line-clamp-2 md:truncate" style={{ fontFamily: "Archivo" }}>
              {t("irs_banner_title")}
            </h3>
            <span className="hidden sm:block mt-1.5 md:mt-2 text-[11px] md:text-sm text-white/55 truncate" style={{ fontFamily: "Inter" }}>
              {t("irs_banner_claim")}
            </span>
          </div>
          <div className="flex items-center shrink-0">
            <span
              className="inline-flex items-center gap-2 px-4 md:px-6 py-2.5 text-[11px] md:text-sm font-bold uppercase tracking-[0.12em] text-black whitespace-nowrap transition-transform group-hover:translate-x-0.5"
              style={{ fontFamily: "Space Grotesk", background: brand.yellow }}
            >
              {t("irs_banner_cta")} <ArrowRight size={15} />
            </span>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default IrsBanner;
